import { useState, useEffect, useMemo } from "react";
import RoomSceneList from '../RoomSceneList/RoomSceneList';
import TopMenu from '../TopMenu/TopMenu';
import styles from './RoomscenePage.module.css';
import loading from './assets/loading.png';

export default function RoomScenePage() {
  const [sceneData, setSceneData] = useState([]);
  const [sceneFilters, setSceneFilters] = useState(['all']);

  useEffect(() => {
    const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${8636}.json`;
    fetch(URL)
      .then(r => r.json())
      .then((data) => {
        const unique = [];
        for (const scene of data) {
            if(!unique.includes(scene.description)){
                unique.push(scene.description)
            }
        }
        setSceneData(unique);
      })
  }, []);


  // toggle handler (multi-select)
  const handleSceneFilter = (type) => {
    setSceneFilters(prev => {
      if (type === 'all') return ['all']; // reset

      // remove 'all' if present
      const withoutAll = prev.filter(t => t !== 'all');

      // toggle the type
      const exists = withoutAll.includes(type);
      const next = exists
        ? withoutAll.filter(t => t !== type)
        : [...withoutAll, type];

      // if empty, revert to 'all'
      return next.length === 0 ? ['all'] : next;
    });
  };


  return (
    <>
      <TopMenu extended={false} page='roomscenes' />

      <section className={styles.roomsceneSection}>
        <div className={styles.content}>
                <h4>Let's Start Visualizing</h4>
                <h2>Select your roomscenes to begin</h2>


          <div className={styles.sceneLists}>
            <button
              type="button"
              key="all"
              className={sceneFilters.indexOf('all') != -1 ? styles.active : ''}
              onClick={() => handleSceneFilter('all')}
            >
              All
            </button>

            {sceneData.length === 0 ? (
              <p className={styles.muted}>Loading roomscenes…</p>
            ) : (
              sceneData.map(sceneType => (
                <button
                  type="button"
                  key={sceneType}
                  className={ sceneFilters.indexOf(sceneType) != -1 ? styles.active : ''}
                  onClick={() => handleSceneFilter(sceneType)}
                >
                  {sceneType}
                </button>
              ))
            )}
          </div>

          <RoomSceneList scenes={sceneFilters} seriesId="8636" thumbnailSize={600} />
        </div>

        <div id="loadScreen" className={styles.loadScreen}>
          <img src={loading} alt="loading logo" />
        </div>
      </section>
    </>
  );
}
